import React from "react";
import { useContent } from "@/lib/content";

export default function ServicesMarquee({ inverted = false }) {
  const { marquee: MARQUEE_SERVICES, branding = {} } = useContent();
  const items = [...MARQUEE_SERVICES, ...MARQUEE_SERVICES];
  const speed = Math.max(8, Number(branding.marquee_speed_seconds) || 40);
  return (
    <div className={`${inverted ? "theme-light" : "theme-dark"} py-10 border-y ${inverted ? "border-black/10" : "border-white/10"} overflow-hidden`} data-testid="services-marquee">
      <div className="marquee-track flex gap-16 whitespace-nowrap will-change-transform" style={{ animationDuration: `${speed}s` }}>
        {items.map((s, i) => (
          <span key={`mq-${i}-${s}`} className="font-display text-5xl md:text-7xl lg:text-8xl tracking-tighter flex items-center gap-16">
            {s}
            <span className="inline-block w-3 h-3 rounded-full bg-accent-yellow" />
          </span>
        ))}
      </div>
    </div>
  );
}
